module.exports = __webpack_public_path__ + "img/100GBP.cce3635c.png";